const SET_MODE = 'SET_MODE';
const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
const SET_SEARCH = 'SET_SEARCH';
const SET_ORDER_BY = 'SET_ORDER_BY';
const SET_AUTHORITY_ORDER_BY = 'SET_AUTHORITY_ORDER_BY';

const state = {
  mode: 'basic',
  activeTab: 'live',
  lostBacklinks: [],
  disavowedBacklinks: [],
  search: '',
  orderBy: 'found',
  orderDirection: 'desc',
  authorityOrderBy: 'date',
  authorityOrderDirection: 'asc',
};

const getters = {
  errors: ({errors}) => errors,
  mode: ({mode}) => mode,
  activeTab: ({activeTab}) => activeTab,
  search: ({search}) => search,
  orderBy: ({orderBy}) => orderBy,
  orderDirection: ({orderDirection}) => orderDirection,
  authorityOrderBy: ({authorityOrderBy}) => authorityOrderBy,
  authorityOrderDirection: ({authorityOrderDirection}) => authorityOrderDirection,
};

const actions = {
  setMode: ({commit}, mode) => commit(SET_MODE, mode),
  setActiveTab: ({commit}, tab) => commit(SET_ACTIVE_TAB, tab),
  setSearch: ({commit}, search) => commit(SET_SEARCH, search),
  setOrderBy: ({commit}, orderBy) => commit(SET_ORDER_BY, orderBy),
  setAuthorityOrderBy: ({commit}, orderBy) => commit(SET_AUTHORITY_ORDER_BY, orderBy),
};

const mutations = {
  [SET_MODE](state, mode) {
    state.mode = mode;
  },
  [SET_ACTIVE_TAB](state, tab) {
    state.activeTab = tab;
  },
  [SET_SEARCH](state, search) {
    state.search = search;
  },
  [SET_ORDER_BY](state, orderBy) {
    if (orderBy === state.orderBy) {
      state.orderDirection = state.orderDirection === 'asc' ? 'desc' : 'asc';
      return;
    }
    state.orderBy = orderBy;
    state.orderDirection = 'desc';
  },
  [SET_AUTHORITY_ORDER_BY](state, orderBy) {
    if (orderBy === state.authorityOrderBy) {
      state.authorityOrderDirection = state.authorityOrderDirection === 'asc' ? 'desc' : 'asc';
      return;
    }
    state.authorityOrderBy = orderBy;
    state.authorityOrderDirection = 'asc';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
